/**
 * dialogs translations
 * Auto-split from staticTranslations.ts
 */

// ─── Ring Size Guide Dialog ─────────────────────────────────────────
export const ringSizeDialog = {
  en: {
    triggerLabel: "Ring Size Guide",
    title: "Ring Size Guide",
    circumference: "Finger Circumference (mm)",
    size: "Size",
  },
  ru: {
    triggerLabel: "Таблица размеров колец",
    title: "Таблица размеров колец",
    circumference: "Окружность пальца (мм)",
    size: "Размер",
  },
  ar: {
    triggerLabel: "دليل مقاسات الخواتم",
    title: "دليل مقاسات الخواتم",
    circumference: "محيط الإصبع (مم)",
    size: "المقاس",
  },
};

// ─── Cookie Banner ─────────────────────────────────────────
export const cookieBanner = {
  en: {
    title: "We use cookies",
    description: "We use cookies and similar technologies to improve your browsing experience, personalize content and ads, provide social media features and analyze site traffic. Some cookies are essential for proper site operation, while others help us improve our service.",
    learnMore: "Learn more",
    acceptAll: "Accept All Cookies",
    rejectAll: "Reject Non-Essential Cookies",
    managePreferences: "Manage Preferences",
  },
  ru: {
    title: "Мы используем файлы cookie",
    description: "Мы используем файлы cookie и аналогичные технологии для улучшения вашего опыта просмотра, персонализации контента и рекламы, предоставления функций социальных сетей и анализа трафика. Некоторые cookie необходимы для работы сайта, другие помогают нам улучшить сервис.",
    learnMore: "Подробнее",
    acceptAll: "Принять все cookie",
    rejectAll: "Отклонить необязательные cookie",
    managePreferences: "Управление настройками",
  },
  ar: {
    title: "نحن نستخدم ملفات تعريف الارتباط",
    description: "نستخدم ملفات تعريف الارتباط وتقنيات مشابهة لتحسين تجربة التصفح وتخصيص المحتوى والإعلانات وتوفير ميزات وسائل التواصل الاجتماعي وتحليل حركة المرور. بعض ملفات تعريف الارتباط ضرورية لعمل الموقع، بينما يساعدنا البعض الآخر في تحسين خدمتنا.",
    learnMore: "اقرأ المزيد",
    acceptAll: "قبول جميع ملفات تعريف الارتباط",
    rejectAll: "رفض ملفات تعريف الارتباط غير الضرورية",
    managePreferences: "إدارة التفضيلات",
  },
};

// ─── Cookie Preferences Modal ─────────────────────────────────────────
export const cookiePreferences = {
  en: {
    title: "Cookie Preferences",
    description: "Manage your cookie preferences. You can enable or disable different types of cookies below.",
    acceptAll: "Accept All",
    rejectAll: "Reject All",
    savePreferences: "Save Preferences",
    alwaysActive: "Always Active",
    necessaryTitle: "Necessary Cookies",
    necessaryDesc: "These cookies are essential for the website to function properly. They cannot be disabled.",
    analyticsTitle: "Analytics Cookies",
    analyticsDesc: "These cookies help us understand how visitors interact with the website by collecting and reporting information anonymously.",
    marketingTitle: "Marketing Cookies",
    marketingDesc: "These cookies are used to track visitors across websites to display relevant advertisements.",
    functionalTitle: "Functional Cookies",
    functionalDesc: "These cookies enable the website to provide enhanced functionality and personalization.",
  },
  ru: {
    title: "Настройки cookie",
    description: "Управляйте настройками cookie. Вы можете включить или отключить различные типы cookie.",
    acceptAll: "Принять все",
    rejectAll: "Отклонить все",
    savePreferences: "Сохранить настройки",
    alwaysActive: "Всегда активны",
    necessaryTitle: "Необходимые cookie",
    necessaryDesc: "Эти cookie необходимы для правильной работы сайта. Их нельзя отключить.",
    analyticsTitle: "Аналитические cookie",
    analyticsDesc: "Помогают нам понять, как посетители взаимодействуют с сайтом.",
    marketingTitle: "Маркетинговые cookie",
    marketingDesc: "Используются для отслеживания посетителей и показа релевантной рекламы.",
    functionalTitle: "Функциональные cookie",
    functionalDesc: "Обеспечивают расширенные функции и персонализацию.",
  },
  ar: {
    title: "تفضيلات ملفات تعريف الارتباط",
    description: "أدر تفضيلات ملفات تعريف الارتباط. يمكنك تمكين أو تعطيل أنواع مختلفة أدناه.",
    acceptAll: "قبول الكل",
    rejectAll: "رفض الكل",
    savePreferences: "حفظ التفضيلات",
    alwaysActive: "نشط دائمًا",
    necessaryTitle: "ملفات تعريف الارتباط الضرورية",
    necessaryDesc: "ضرورية لعمل الموقع بشكل صحيح. لا يمكن تعطيلها.",
    analyticsTitle: "ملفات تعريف الارتباط التحليلية",
    analyticsDesc: "تساعدنا على فهم كيفية تفاعل الزوار مع الموقع.",
    marketingTitle: "ملفات تعريف الارتباط التسويقية",
    marketingDesc: "تُستخدم لتتبع الزوار وعرض إعلانات ذات صلة.",
    functionalTitle: "ملفات تعريف الارتباط الوظيفية",
    functionalDesc: "تتيح وظائف محسّنة وتخصيصًا.",
  },
};

// ─── Alert Dialog / Confirm ─────────────────────────────────────────
export const confirmDialog = {
  en: {
    deleteMessage: "Delete this message?", deleteMessageDesc: "This action cannot be undone. The message will be permanently deleted.",
    cancel: "Cancel", delete: "Delete",
    deleteCategory: "Delete Category", deleteCategoryDesc: "Are you sure you want to delete this category? This will also delete all questions in it.",
    deleteQuestion: "Delete Question", deleteQuestionDesc: "Are you sure you want to delete this question?",
  },
  ru: {
    deleteMessage: "Удалить это сообщение?", deleteMessageDesc: "Это действие нельзя отменить. Сообщение будет удалено навсегда.",
    cancel: "Отмена", delete: "Удалить",
    deleteCategory: "Удалить категорию", deleteCategoryDesc: "Вы уверены, что хотите удалить эту категорию? Все вопросы в ней также будут удалены.",
    deleteQuestion: "Удалить вопрос", deleteQuestionDesc: "Вы уверены, что хотите удалить этот вопрос?",
  },
  ar: {
    deleteMessage: "حذف هذه الرسالة؟", deleteMessageDesc: "لا يمكن التراجع عن هذا الإجراء. سيتم حذف الرسالة نهائياً.",
    cancel: "إلغاء", delete: "حذف",
    deleteCategory: "حذف الفئة", deleteCategoryDesc: "هل أنت متأكد من حذف هذه الفئة؟ سيتم حذف جميع الأسئلة فيها أيضاً.",
    deleteQuestion: "حذف السؤال", deleteQuestionDesc: "هل أنت متأكد من حذف هذا السؤال؟",
  },
};
